"use client";

import { Users, ChevronDown, Heart, Star } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Empowering() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="870" id="empowering-independence" className="relative text-white overflow-hidden min-h-[92vh] flex items-center !bg-[rgba(1,1,8,1)]">
      {}
      <div className="pointer-events-none absolute inset-0 opacity-[0.05] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>\")"
    }} aria-hidden="true" />

      {}
      <div className="pointer-events-none absolute inset-0" style={{
      background: "radial-gradient(ellipse 60% 50% at 10% 90%, hsl(195 100% 40% / 0.18), transparent 60%)"
    }} aria-hidden="true" />

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-6 lg:px-12 pt-28 pb-24 lg:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          {}
          <div ref={leftRef} className={`lg:col-span-7 order-2 lg:order-1 transition-all duration-1000 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {}

            {}
            <h1 className="font-serif font-medium tracking-tight text-white leading-[1.02] mb-8 !text-center !text-6xl" style={{
            fontSize: "clamp(48px, 9vw, 140px)",
            letterSpacing: "-0.02em"
          }}>
              Dedicated to fostering{" "}
              <span className="italic font-light">our Community Members growth and</span>{" "}
              <span className="relative inline-block italic font-light">
                independence
                <svg className="absolute -bottom-2 left-0 w-full" viewBox="0 0 300 20" fill="none" preserveAspectRatio="none" aria-hidden="true" style={{
                height: "0.5em"
              }}>
                  <path d="M2 12 Q 75 2, 150 10 T 298 8" stroke="#0099CC" strokeWidth="3" strokeLinecap="round" fill="none" />
                </svg>
              </span>
            </h1>

            {}
            <p className="font-default text-[18px] leading-relaxed text-slate-300 max-w-[520px] mb-10 !text-left md:text-[20px]">We provide services for adults with special needs. Specialized independence that best suites their needs.<br /></p>

            {}
            <div className="flex flex-wrap items-center gap-4 mb-8">
              <Button size="lg" className="rounded-lg h-14 px-7 bg-[#0099CC] text-white hover:bg-[#0088BB] font-medium text-base shadow-lg">
                <Heart className="size-5" />
                Request Services
              </Button>

              <Button size="lg" variant="outline" className="rounded-lg h-14 px-7 bg-transparent border-slate-500 text-white hover:bg-white/10 font-medium text-base">
                <Users className="size-5" />
                Join Our Team
              </Button>
            </div>

            {}
            <div className="flex items-center gap-3 font-mono text-xs uppercase tracking-[0.15em] text-slate-400">
              <div className="flex items-center gap-0.5">
                {[0, 1, 2, 3, 4].map(i => <Star key={i} data-index={i} className="size-3.5 fill-current" style={{
                color: "#0099CC"
              }} />)}
              </div>
              <span>DDS Certified</span>
              <span className="text-slate-500/40">•</span>
              <span>Trusted Provider</span>
            </div>
          </div>

          {}
          <div ref={rightRef} className={`lg:col-span-5 order-1 lg:order-2 relative transition-all duration-1000 ease-out delay-200 ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {}
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-10 left-0 right-0 pointer-events-none px-6 lg:px-12">
        <svg viewBox="0 0 1400 60" className="w-full h-10 opacity-30" preserveAspectRatio="none" aria-hidden="true">
          {Array.from({
          length: 120
        }).map((_, i) => {
          const h = 8 + Math.abs(Math.sin(i * 0.4)) * 40 + Math.abs(Math.cos(i * 0.27)) * 12;
          return <rect key={i} data-index={i} x={i * 12} y={30 - h / 2} width="3" height={h} rx="1.5" fill="currentColor" className="text-slate-500" style={{
            animation: `wave-pulse 2.4s ease-in-out ${i % 12 * 0.1}s infinite`
          }} />;
        })}
        </svg>
      </div>

      {}
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.3em] text-slate-400">
        <span>Scroll</span>
        <ChevronDown className="size-3 animate-bounce" />
      </div>

      <style>{`
        @keyframes wave-pulse {
          0%, 100% { transform: scaleY(0.6); transform-origin: center; }
          50% { transform: scaleY(1.1); transform-origin: center; }
        }
      `}</style>
    </section>;
}